export enum PermissionCategory {
  PROFILE = "PROFILE",
  CLIENTS = "CLIENTS",
  INSURANCES = "INSURANCES",
  LOANS = "LOANS",
  INVESTMENTS = "INVESTMENTS",
  DEPOSITS = "DEPOSITS",
  SECOND_PILLARS = "SECOND_PILLARS",
  THIRD_PILLARS = "THIRD_PILLARS",
  GENERICS = "GENERICS",
  CONTRACTS = "CONTRACTS",
  CALCULATORS = "CALCULATORS",
  PARTNERS = "PARTNERS",
  AGENTS = "AGENTS",
  COMMISSIONS = "COMMISSIONS",
  ADMIN = "ADMIN",
  SYSTEM = "SYSTEM",
}

export enum PermissionFinancialSector {
  INSURANCES_OR_REINSURANCES = "INSURANCES_OR_REINSURANCES",
  LOANS_AND_MORTGAGES = "LOANS_AND_MORTGAGES",
  CAPITAL_MARKET = "CAPITAL_MARKET",
  DEPOSITS = "DEPOSITS",
  SENIOR_PENSION_SAVINGS = "SENIOR_PENSION_SAVINGS",
  SUPPLEMENTARY_PENSION_SAVINGS = "SUPPLEMENTARY_PENSION_SAVINGS",
  OTHERS = "OTHERS",
}

export enum Feature {
  INSURANCES = "INSURANCES",
  LOANS = "LOANS",
  INVESTMENTS = "INVESTMENTS",
  DEPOSITS = "DEPOSITS",
  SECOND_PILLARS = "SECOND_PILLARS",
  THIRD_PILLARS = "THIRD_PILLARS",
  GENERICS = "GENERICS",
  MTPL_CALCULATORS = "MTPL_CALCULATORS",
  CRASH_CALCULATORS = "CRASH_CALCULATORS",
  REALTY_CALCULATORS = "REALTY_CALCULATORS",
  TRAVEL_CALCULATORS = "TRAVEL_CALCULATORS",
  CLIENT_ACCESS = "CLIENT_ACCESS",
  PARTNERS = "PARTNERS",
  AGENTS = "AGENTS",
  COMMISSIONS = "COMMISSIONS",
}

export enum Permission {
  PROFILE_COMMISSIONS = "PROFILE_COMMISSIONS",
  PROFILE_COMPETENCE = "PROFILE_COMPETENCE",
  PROFILE_LICENSE = "PROFILE_LICENSE",
  PROFILE_BROKER_NUMBER = "PROFILE_BROKER_NUMBER",
  PROFILE_EDUCATION = "PROFILE_EDUCATION",
  PROFILE_MENTORING = "PROFILE_MENTORING",

  CLIENT_READ = "CLIENT_READ",
  CLIENT_CREATE = "CLIENT_CREATE",
  CLIENT_UPDATE = "CLIENT_UPDATE",
  CLIENT_MANAGED_BY_CHANGE = "CLIENT_MANAGED_BY_CHANGE",
  PRIVILEGED_CLIENT_MANAGED_BY_CHANGE = "PRIVILEGED_CLIENT_MANAGED_BY_CHANGE",
  CLIENT_ASSIGNED_AGENTS_CHANGE = "CLIENT_ASSIGNED_AGENTS_CHANGE",
  CLIENT_DELETE = "CLIENT_DELETE",
  CLIENT_ACCOUNTS = "CLIENT_ACCOUNTS",
  CLIENT_IMPORT = "CLIENT_IMPORT",
  CLIENT_EXPORT = "CLIENT_EXPORT",

  INSURANCE_READ = "INSURANCE_READ",
  INSURANCE_CREATE = "INSURANCE_CREATE",
  INSURANCE_LIMITED_UPDATE = "INSURANCE_LIMITED_UPDATE",
  INSURANCE_UPDATE = "INSURANCE_UPDATE",
  INSURANCE_DELETE = "INSURANCE_DELETE",

  INSURANCE_OWN_VERIFICATION_SEND = "INSURANCE_OWN_VERIFICATION_SEND",
  INSURANCE_DIRECTORATE_VERIFICATION_SEND = "INSURANCE_DIRECTORATE_VERIFICATION_SEND",
  INSURANCE_VERIFICATION_STATUS_CHANGE = "INSURANCE_VERIFICATION_STATUS_CHANGE",
  PRIVILEGED_CHANGES_ON_VERIFIED_INSURANCE = "PRIVILEGED_CHANGES_ON_VERIFIED_INSURANCE",

  LOAN_READ = "LOAN_READ",
  LOAN_CREATE = "LOAN_CREATE",
  LOAN_LIMITED_UPDATE = "LOAN_LIMITED_UPDATE",
  LOAN_UPDATE = "LOAN_UPDATE",
  LOAN_DELETE = "LOAN_DELETE",

  LOAN_OWN_VERIFICATION_SEND = "LOAN_OWN_VERIFICATION_SEND",
  LOAN_DIRECTORATE_VERIFICATION_SEND = "LOAN_DIRECTORATE_VERIFICATION_SEND",
  LOAN_VERIFICATION_STATUS_CHANGE = "LOAN_VERIFICATION_STATUS_CHANGE",
  PRIVILEGED_CHANGES_ON_VERIFIED_LOAN = "PRIVILEGED_CHANGES_ON_VERIFIED_LOAN",

  INVESTMENT_READ = "INVESTMENT_READ",
  INVESTMENT_CREATE = "INVESTMENT_CREATE",
  INVESTMENT_LIMITED_UPDATE = "INVESTMENT_LIMITED_UPDATE",
  INVESTMENT_UPDATE = "INVESTMENT_UPDATE",
  INVESTMENT_DELETE = "INVESTMENT_DELETE",

  INVESTMENT_OWN_VERIFICATION_SEND = "INVESTMENT_OWN_VERIFICATION_SEND",
  INVESTMENT_DIRECTORATE_VERIFICATION_SEND = "INVESTMENT_DIRECTORATE_VERIFICATION_SEND",
  INVESTMENT_VERIFICATION_STATUS_CHANGE = "INVESTMENT_VERIFICATION_STATUS_CHANGE",
  PRIVILEGED_CHANGES_ON_VERIFIED_INVESTMENT = "PRIVILEGED_CHANGES_ON_VERIFIED_INVESTMENT",

  DEPOSIT_READ = "DEPOSIT_READ",
  DEPOSIT_CREATE = "DEPOSIT_CREATE",
  DEPOSIT_LIMITED_UPDATE = "DEPOSIT_LIMITED_UPDATE",
  DEPOSIT_UPDATE = "DEPOSIT_UPDATE",
  DEPOSIT_DELETE = "DEPOSIT_DELETE",

  DEPOSIT_OWN_VERIFICATION_SEND = "DEPOSIT_OWN_VERIFICATION_SEND",
  DEPOSIT_DIRECTORATE_VERIFICATION_SEND = "DEPOSIT_DIRECTORATE_VERIFICATION_SEND",
  DEPOSIT_VERIFICATION_STATUS_CHANGE = "DEPOSIT_VERIFICATION_STATUS_CHANGE",
  PRIVILEGED_CHANGES_ON_VERIFIED_DEPOSIT = "PRIVILEGED_CHANGES_ON_VERIFIED_DEPOSIT",

  SECOND_PILLAR_READ = "SECOND_PILLAR_READ",
  SECOND_PILLAR_CREATE = "SECOND_PILLAR_CREATE",
  SECOND_PILLAR_LIMITED_UPDATE = "SECOND_PILLAR_LIMITED_UPDATE",
  SECOND_PILLAR_UPDATE = "SECOND_PILLAR_UPDATE",
  SECOND_PILLAR_DELETE = "SECOND_PILLAR_DELETE",

  SECOND_PILLAR_OWN_VERIFICATION_SEND = "SECOND_PILLAR_OWN_VERIFICATION_SEND",
  SECOND_PILLAR_DIRECTORATE_VERIFICATION_SEND = "SECOND_PILLAR_DIRECTORATE_VERIFICATION_SEND",
  SECOND_PILLAR_VERIFICATION_STATUS_CHANGE = "SECOND_PILLAR_VERIFICATION_STATUS_CHANGE",
  PRIVILEGED_CHANGES_ON_VERIFIED_SECOND_PILLAR = "PRIVILEGED_CHANGES_ON_VERIFIED_SECOND_PILLAR",

  THIRD_PILLAR_READ = "THIRD_PILLAR_READ",
  THIRD_PILLAR_CREATE = "THIRD_PILLAR_CREATE",
  THIRD_PILLAR_LIMITED_UPDATE = "THIRD_PILLAR_LIMITED_UPDATE",
  THIRD_PILLAR_UPDATE = "THIRD_PILLAR_UPDATE",
  THIRD_PILLAR_DELETE = "THIRD_PILLAR_DELETE",

  THIRD_PILLAR_OWN_VERIFICATION_SEND = "THIRD_PILLAR_OWN_VERIFICATION_SEND",
  THIRD_PILLAR_DIRECTORATE_VERIFICATION_SEND = "THIRD_PILLAR_DIRECTORATE_VERIFICATION_SEND",
  THIRD_PILLAR_VERIFICATION_STATUS_CHANGE = "THIRD_PILLAR_VERIFICATION_STATUS_CHANGE",
  PRIVILEGED_CHANGES_ON_VERIFIED_THIRD_PILLAR = "PRIVILEGED_CHANGES_ON_VERIFIED_THIRD_PILLAR",

  GENERIC_READ = "GENERIC_READ",
  GENERIC_CREATE = "GENERIC_CREATE",
  GENERIC_LIMITED_UPDATE = "GENERIC_LIMITED_UPDATE",
  GENERIC_UPDATE = "GENERIC_UPDATE",
  GENERIC_DELETE = "GENERIC_DELETE",

  GENERIC_OWN_VERIFICATION_SEND = "GENERIC_OWN_VERIFICATION_SEND",
  GENERIC_DIRECTORATE_VERIFICATION_SEND = "GENERIC_DIRECTORATE_VERIFICATION_SEND",
  GENERIC_VERIFICATION_STATUS_CHANGE = "GENERIC_VERIFICATION_STATUS_CHANGE",
  PRIVILEGED_CHANGES_ON_VERIFIED_GENERIC = "PRIVILEGED_CHANGES_ON_VERIFIED_GENERIC",

  CONTRACT_IMPORT = "CONTRACT_IMPORT",
  CONTRACT_EXPORT = "CONTRACT_EXPORT",
  CONTRACT_VERIFICATION_EXPORT = "CONTRACT_VERIFICATION_EXPORT",

  MTPL_CALCULATE = "MTPL_CALCULATE",
  MTPL_GENERATE_CONTRACT = "MTPL_GENERATE_CONTRACT",

  CRASH_CALCULATE = "CRASH_CALCULATE",
  CRASH_GENERATE_CONTRACT = "CRASH_GENERATE_CONTRACT",

  REALTY_CALCULATE = "REALTY_CALCULATE",
  REALTY_GENERATE_CONTRACT = "REALTY_GENERATE_CONTRACT",

  TRAVEL_CALCULATE = "TRAVEL_CALCULATE",
  TRAVEL_GENERATE_CONTRACT = "TRAVEL_GENERATE_CONTRACT",

  CARD_READER = "CARD_READER",

  PARTNER_INSURANCE_COMPANIES = "PARTNER_INSURANCE_COMPANIES",
  PARTNER_BANKS = "PARTNER_BANKS",
  PARTNER_SECURITIES_BROKERS = "PARTNER_SECURITIES_BROKERS",
  PARTNER_BUILDING_SAVINGS_BANKS = "PARTNER_BUILDING_SAVINGS_BANKS",
  PARTNER_MANAGERIAL_PENSION_COMPANIES = "PARTNER_MANAGERIAL_PENSION_COMPANIES",
  PARTNER_SUPPLEMENTARY_PENSION_COMPANIES = "PARTNER_SUPPLEMENTARY_PENSION_COMPANIES",
  PARTNER_OTHERS = "PARTNER_OTHERS",

  AGENT_READ = "AGENT_READ",
  AGENT_CREATE = "AGENT_CREATE",
  AGENT_UPDATE = "AGENT_UPDATE",
  AGENT_DELETE = "AGENT_DELETE",
  AGENT_USER_INVITE = "AGENT_USER_INVITE",
  AGENT_IMPORT = "AGENT_IMPORT",
  AGENT_EXPORT = "AGENT_EXPORT",

  AGENT_COMMISSIONS = "AGENT_COMMISSIONS",
  AGENT_COMMISSIONS_SETTINGS = "AGENT_COMMISSIONS_SETTINGS",
  AGENT_COMMISSIONS_SETTINGS_MANAGE = "AGENT_COMMISSIONS_SETTINGS_MANAGE",

  AGENT_COMPETENCE = "AGENT_COMPETENCE",
  AGENT_COMPETENCE_MANAGE = "AGENT_COMPETENCE_MANAGE",
  AGENT_LICENSE = "AGENT_LICENSE",
  AGENT_LICENSE_MANAGE = "AGENT_LICENSE_MANAGE",
  AGENT_BROKER_NUMBER = "AGENT_BROKER_NUMBER",
  AGENT_BROKER_NUMBER_MANAGE = "AGENT_BROKER_NUMBER_MANAGE",
  AGENT_EDUCATION = "AGENT_EDUCATION",
  AGENT_EDUCATION_MANAGE = "AGENT_EDUCATION_MANAGE",
  AGENT_MENTORING = "AGENT_MENTORING",
  AGENT_MENTORING_MANAGE = "AGENT_MENTORING_MANAGE",

  COMMISSIONS = "COMMISSIONS",
  COMMISSIONS_MANAGE = "COMMISSIONS_MANAGE",
  POSTPONED_COMMISSIONS = "POSTPONED_COMMISSIONS",
  POSTPONED_COMMISSIONS_MANAGE = "POSTPONED_COMMISSIONS_MANAGE",
  TOP_AGENT_COMMISSIONS = "TOP_AGENT_COMMISSIONS",
  TOP_AGENT_COMMISSIONS_MANAGE = "TOP_AGENT_COMMISSIONS_MANAGE",

  ADMIN_DASHBOARD = "ADMIN_DASHBOARD",
  ADMIN_DASHBOARD_GOALS = "ADMIN_DASHBOARD_GOALS",
  ADMIN_USERS = "ADMIN_USERS",
  ADMIN_ENUMERATIONS = "ADMIN_ENUMERATIONS",
  ADMIN_DOCUMENT_NODES = "ADMIN_DOCUMENT_NODES",
  ADMIN_MTPL_CALCULATORS = "ADMIN_MTPL_CALCULATORS",
  ADMIN_CRASH_CALCULATORS = "ADMIN_CRASH_CALCULATORS",
  ADMIN_REALTY_CALCULATORS = "ADMIN_REALTY_CALCULATORS",
  ADMIN_TRAVEL_CALCULATORS = "ADMIN_TRAVEL_CALCULATORS",
  ADMIN_PARTNER_CONFIGS = "ADMIN_PARTNER_CONFIGS",

  ADMIN_TOP_AGENTS = "ADMIN_TOP_AGENTS",
  ADMIN_GLOBAL_ENUMERATIONS = "ADMIN_GLOBAL_ENUMERATIONS",
  ADMIN_JOBS = "ADMIN_JOBS",
  ADMIN_SYSTEM_CONFIG = "ADMIN_SYSTEM_CONFIG",
}

export enum Role {
  AGENT = "AGENT",
  CLIENT = "CLIENT",
}
